// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"77ab36e7","387":"57354016","657":"55094b48","840":"083543ee","890":"457c065f","932":"8a3c7d15"}[chunkId] + ".chunk.css";
};